import React from "react";
import { Container, Wrapper } from "./styles";
import iconImg from "../../assets/images/code-64.ico";

export default function AnimatedBackground() {
  return (
    <Container>
      <Wrapper>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
        <div>
          <img src={iconImg} alt="code" />
        </div>
      </Wrapper>
    </Container>
  );
}
